import { render } from "./MediaLibraryRightArea.vue?vue&type=template&id=750d7ca4"
import script from "./MediaLibraryRightArea.vue?vue&type=script&lang=js"
export * from "./MediaLibraryRightArea.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "750d7ca4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('750d7ca4', script)) {
    api.reload('750d7ca4', script)
  }
  
  module.hot.accept("./MediaLibraryRightArea.vue?vue&type=template&id=750d7ca4", () => {
    api.rerender('750d7ca4', render)
  })

}

script.__file = "resources/js/Pages/Media/MediaLibraryRightArea.vue"

export default script